import { AWFTableColumn } from '@ansys-internal/awf-angular/core';
import { ContributionsEnum } from '../../contributions.enum';
import { TableColumn } from '@ansys-internal/awf-angular/contributions';
import {
  AWCTableCell,
  TableCellAlign,
  TableCellTypes,
} from '@ansys-internal/awc-angular/tables';
import { DriveCycleTableType } from '../../../shared/types/drive-cycle-table.type';
import { ScientificNotationPipe } from '../../../shared/pipes/scientific-notation/scientific-notation.pipe';
import { UnitChoice } from '../../../shared/types';
import { UnitType } from '../../../../api';
import { ConceptUnitService } from '../../../shared/services/unit.service';
import { Subscription } from 'rxjs';

@AWFTableColumn({
  id: ContributionsEnum.DRIVE_CYCLE_TABLE_TOTAL_DISTANCE_COLUMN,
  priority: 100,
})
export class DriveCycleTableTotalDistanceColumn implements TableColumn {
  id: string = ContributionsEnum.DRIVE_CYCLE_TABLE_TOTAL_DISTANCE_COLUMN;
  priority: number = 200;
  align: TableCellAlign = TableCellAlign.LEFT;
  headerString: string = 'Total Distance';
  header: string = this.headerString;
  type: TableCellTypes = TableCellTypes.TEXT;
  width: number = 130;
  private choicesSubscription: Subscription;

  constructor(
    private snPipe: ScientificNotationPipe,
    private conceptUnitService: ConceptUnitService
  ) {
    this.choicesSubscription = this.conceptUnitService.choices$.subscribe(
      () => {
        this.header =
          this.headerString +
          ' (' +
          this.conceptUnitService.getChoice(UnitType.DISTANCE) +
          ')';
      }
    );
  }

  public async render(data: DriveCycleTableType): Promise<AWCTableCell> {
    return { value: this.snPipe.transform(data.totalDistance) };
  }
}
